<div
  class="form-control__wrapper"
  [ngClass]="{ 'form-control__wrapper--flat': direction === 'filter' }"
>
  <label class="form-control__label">
    <p class="t-bold">{{ config.label }}</p>
  </label>

  <div class="form-control" (click)="menuOpen = !menuOpen">
    <div class="u-flex u-alignCenter u-maxXY">
      @if (selectedColor) {
        <div
          class="swatch"
          [ngClass]="{
            'swatch--transparent':
              selectedColor.label === brandColorLabels.TRANSPARENT,
          }"
          [ngStyle]="{ 'background-color': selectedColor.value }"
        ></div>
        <p>{{ selectedColor.label }}</p>
        @if (selectedColor.label !== brandColorLabels.TRANSPARENT) {
          <div class="u-flex u-justifyEnd u-fillRemaining">
            <code class="t-caps">
              @switch (selectedColor.label) {
                @case (brandColorLabels.WHITE) {
                  <span>#ffffff</span>
                }
                @case (brandColorLabels.BLACK) {
                  <span>#000000</span>
                }
                @default {
                  <span>{{ getHex(selectedColor.var) }}</span>
                }
              }
            </code>
          </div>
        }
      } @else {
        <p>Select a brand color</p>
      }
    </div>
  </div>

  @if (menuOpen) {
    <div class="form-control__menu">
      @for (set of palette; track set) {
        <div class="form-control__menu__header">
          <p class="t-alt t-caption">{{ set.label }}</p>
        </div>
        @for (color of set.colors; track color; let i = $index) {
          <div
            class="form-control__menu__option"
            [ngClass]="{ 'is-active': color === selectedColor }"
            (click)="selectColor(color)"
          >
            <div class="u-flex u-alignCenter u-maxX">
              <div
                class="swatch"
                [ngClass]="{
                  'swatch--transparent':
                    color.label === brandColorLabels.TRANSPARENT,
                }"
                [ngStyle]="{ 'background-color': color.value }"
              ></div>
              <p>{{ color.label }}</p>
              @if (color.label !== brandColorLabels.TRANSPARENT) {
                <div class="u-flex u-justifyEnd u-fillRemaining">
                  <code class="t-caps">
                    @switch (color.label) {
                      @case (brandColorLabels.WHITE) {
                        <span>#ffffff</span>
                      }
                      @case (brandColorLabels.BLACK) {
                        <span>#000000</span>
                      }
                      @default {
                        <span>{{ getHex(color.var) }}</span>
                      }
                    }
                  </code>
                </div>
              }
            </div>
          </div>
        }
      }
    </div>
  }
</div>

@if (menuOpen) {
  <div class="modal__mask" (click)="menuOpen = false"></div>
}
